// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"d277a03e","107":"af6b0736","178":"13f67cc5","196":"6272c1d4","276":"e76a1c17","370":"f6880653","409":"de9cf4dd","479":"0cce2f47","542":"bb310510","579":"16502c72","589":"537f4538","769":"2bd1781d","774":"ba41769f","852":"b66363ff","895":"9c06867c","979":"0429e770"}[chunkId] + ".chunk.js";
};